module.exports = __webpack_public_path__ + "static/tech-c8e2b6fab9f24d88d836acb43bea9c03.jpg";